<script lang="ts">
	import ProductGrid from '$lib/components/ecom/ProductGrid.svelte';
	import ProductPage from '$lib/components/ecom/ProductPage.svelte';
	import { page } from '$app/stores';
	import api from '$lib/api/ecom/shopify';

	import SectionSwitcher from '$lib/components/layout/SectionSwitcher.svelte';
	import { PUBLIC_DIRECTUS_BACKEND, PUBLIC_FRONTEND_URL } from '$env/static/public';
	import { onMount } from 'svelte';
	import { pageList } from '$lib/stores/navStore';

	export let data;
	$: pageData = data.page;

	$: if (data.collection) {
		addCollectionPage($page.data.languages, data.collection);
	} else {
		addProductPage($page.data.languages, $page.data.location, data.product);
	}

	async function addCollectionPage(languages: any[], collection: any) {
		let page: any = {};
		for (const lang of languages) {
			const translation: any = await api.getCollection(collection.id, lang.code);
			page[lang.code] = 'shop/' + translation.collection.handle;
		}

		let exists = false;
		for (const p of $pageList) {
			if (p.en === page.en) {
				exists = true;
			}
		}

		if (!exists) {
			pageList.set([...$pageList, page]);
		}
	}

	async function addProductPage(languages: any[], country: string, product: any) {
		let page: any = {};
		for (const lang of languages) {
			const translation: any = await api.getProductsById(product.id, country, lang.code);
			page[lang.code] = 'shop/' + translation.nodes?.[0]?.handle;
		}

		let exists = false;
		for (const p of $pageList) {
			if (p.en === page.en) {
				exists = true;
			}
		}

		if (!exists) {
			pageList.set([...$pageList, page]);
		}
	}
</script>

<svelte:head>
	{#if data.product}
		<title>{'Bieder & Maier - ' + data.product.title}</title>
		<meta name="description" content={data.product.description} />
		<meta property="og:title" content={data.product.seo.title ?? data.product.title} />
		<meta property="og:url" content={PUBLIC_FRONTEND_URL + $page.url.pathname} />
		<meta
			property="og:description"
			content={data.product.seo.description ?? data.product.description}
		/>
		<meta property="og:image" content={data.product.media?.edges?.[0]?.node?.previewImage?.url} />
	{:else if pageData}
		<title>{pageData.seo_title}</title>
		<meta name="description" content={pageData.seo_description} />

		<meta property="og:title" content={pageData.seo_title} />
		<meta property="og:url" content={PUBLIC_FRONTEND_URL + $page.url.pathname} />
		<meta property="og:description" content={pageData.seo_description} />
		<meta
			property="og:image"
			content={PUBLIC_DIRECTUS_BACKEND + 'assets/' + pageData.seo_image?.id + '.jpg'}
		/>
	{/if}
</svelte:head>

{#if data.collection || !$page.params.slug}
	<ProductGrid {data} />

	<SectionSwitcher sections={data.page?.sections} />
{:else}
	<ProductPage {data} />
{/if}
